export const provinces = [
    "Eastern Cape",
    "Free State",
    "Gauteng",
    "KwaZulu-Natal",
    "Limpopo",
    "Mpumalanga",
    "Northern Cape",
    "North-West",
    "Western Cape"
  ];

  export const schoolTypes = [
    "Primary School",
    "High School",
    "Secondary School",
    "Higher Secondary School",
    "International School",
  ];

  export const grades = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12];

  export const schoolPositions = [
    "Principal",
    "Vice Principal",
    "Head Teacher",
    "Teacher",
    "Assistant Teacher",
    "Coordinator",
    "Librarian",
    "Counselor",
    "Lab Assistant",
    "Support Staff",
    "Other",
  ];

  export const subjects = [
    "Mathematics",
    "Science",
    "Physics",
    "Chemistry",
    "Biology",
    "English",
    "History",
    "Geography",
    "Computer Science",
    "Economics",
    "Political Science",
    "Environmental Studies",
    "Other",
  ];
